export default "__VITE_ASSET__j4nBK0IX__"